import React, { useCallback } from 'react';
import cn from 'classnames';

import { ILabelProps } from './Label.types';

import Guideline from '../Guideline';
import Tooltip from '../Tooltip';

import './Label.scss';

const Label: React.FC<ILabelProps> = ({
	disabled,
	isFieldLabel = true,
	isOverflowLabelText = false,
	label,
	onClick,
	required,
	className,
	tooltipContent,
	tooltipPlacement,
	labelAction,
	labelActionText,
	labelActionTooltip,
	labelActionDisabled,
	tooltipMaxWidth = 520,
}) => {
	const labelClassNames = cn({
		'f5gLabelRequired': required,
		'f5gLabel': !isFieldLabel,
		'f5gLabelOverflow': isOverflowLabelText,
	});

	const labelActionHandler = useCallback(() => {
		if (labelAction && !labelActionDisabled) {
			labelAction();
		}
	}, [labelAction, labelActionDisabled]);

	return (
		<div
			className={cn('f5gLabelContainer', className, {
				'f5gFieldLabel': isFieldLabel,
				'f5gLabelDisabled': disabled,
			})}
			onClick={onClick}
		>
			<span className={labelClassNames}>
				{label}
			</span>
			{tooltipContent
				&& <Guideline
					guidelineText={tooltipContent}
					maxWidth={tooltipMaxWidth}
					placement={tooltipPlacement}
				/>
			}
			{labelAction && labelActionText && (
				<Tooltip
					content={labelActionTooltip}
					placement='top'
				>
					<span
						className={cn('f5gLabelAction', { 'f5gLabelDisabled': labelActionDisabled })}
						onClick={labelActionHandler}
					>
						{labelActionText}
					</span>
				</Tooltip>
			)}
		</div>);
};

export default Label;
